
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface KeyInsightsProps {
  insights: {
    positiveTrends: string;
    areasForImprovement: string;
    platformFocus: string;
  };
}

export const KeyInsights: React.FC<KeyInsightsProps> = ({ insights }) => {
  return (
    <Card className="bg-secondary/50 border-2 border-primary">
      <CardHeader>
        <CardTitle className="text-white">Key Insights</CardTitle>
        <p className="text-[12px] text-white">Note: AI hallucination may occur. Validation of generated information is essential.</p>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="p-4 rounded-md bg-secondary border border-white">
            <h3 className="font-semibold text-primary-light mb-2">Positive Trends</h3>
            <p className="text-sm text-white">
              {insights.positiveTrends || "No positive trends identified. Run an analysis to see insights."}
            </p>
          </div>
          
          <div className="p-4 rounded-md bg-secondary border border-white">
            <h3 className="font-semibold text-primary-light mb-2">Areas for Improvement</h3>
            <p className="text-sm text-white">
              {insights.areasForImprovement || "No improvement areas identified. Run an analysis to see insights."}
            </p>
          </div>
          
          <div className="p-4 rounded-md bg-secondary border border-white">
            <h3 className="font-semibold text-primary-light mb-2">Platform Focus</h3>
            <p className="text-sm text-white">
              {insights.platformFocus || "No platform focus identified. Run an analysis to see insights."}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
